import React, { useEffect, Fragment } from 'react'
import { Transition, Menu, MenuItems, MenuButton, MenuItem } from '@headlessui/react'
import { HiOutlineLogout, HiOutlineUser } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import profileImage from '../../assets/user.png'

export default function Header() {
    const navigate = useNavigate()

    const handleLogout = () => {
        localStorage.clear()
        sessionStorage.clear()
        navigate('/login')
    }

    const [userName, setUserName] = React.useState('')

    useEffect(() => {
        const storedName = localStorage.getItem('name')
        if (storedName) setUserName(storedName)
    }, [])

    return (
        <header className="bg-white h-20 px-6 shadow-md flex items-center border-b border-gray-200 justify-between">
            {/* Brand Section */}
            <div className="flex items-center space-x-4">
                {/* <img src={ascLogo} alt="Logo" className="h-10 w-10 rounded-full object-cover" /> */}
                <div>
                    <h1 className="text-xl font-bold text-red-600">Portal Management System</h1>
                    <p className="text-xs text-gray-500">Centralized platform for administration</p>
                </div>
            </div>

            {/* Right Section */}
            <div className="flex items-center gap-3 mr-2">
                {/* Messages */}
                {/* <Popover className="relative">
                    {({ open }) => (
                        <>
                            <PopoverButton
                                className={classNames(
                                    open && 'bg-gray-100',
                                    'relative group p-2 rounded-full hover:bg-gray-100 focus:outline-none'
                                )}
                            >
                                <HiOutlineChatAlt className="text-gray-700" fontSize={22} />
                                <span className="absolute -top-1 -right-1 inline-flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] text-white">
                                    3
                                </span>
                            </PopoverButton>
                            <Transition
                                as={Fragment}
                                enter="transition ease-out duration-200"
                                enterFrom="opacity-0 translate-y-1"
                                enterTo="opacity-100 translate-y-0"
                                leave="transition ease-in duration-150"
                                leaveFrom="opacity-100 translate-y-0"
                                leaveTo="opacity-0 translate-y-1"
                            >
                                <PopoverPanel className="absolute right-0 z-10 mt-3 w-80">
                                    <div className="bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 px-4 py-3">
                                        <h2 className="font-semibold text-gray-700">Messages</h2>
                                        <p className="text-sm mt-2 text-gray-600">No new messages.</p>
                                    </div>
                                </PopoverPanel>
                            </Transition>
                        </>
                    )}
                </Popover> */}

                {/* Notifications */}
                {/* <Popover className="relative">
                    {({ open }) => (
                        <>
                            <PopoverButton
                                className={classNames(
                                    open && 'bg-gray-100',
                                    'relative group p-2 rounded-full hover:bg-gray-100 focus:outline-none'
                                )}
                            >
                                <HiOutlineBell className="text-gray-700" fontSize={22} />
                                <span className="absolute -top-1 -right-1 inline-flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] text-white">
                                    5
                                </span>
                            </PopoverButton>
                            <Transition
                                as={Fragment}
                                enter="transition ease-out duration-200"
                                enterFrom="opacity-0 translate-y-1"
                                enterTo="opacity-100 translate-y-0"
                                leave="transition ease-in duration-150"
                                leaveFrom="opacity-100 translate-y-0"
                                leaveTo="opacity-0 translate-y-1"
                            >
                                <PopoverPanel className="absolute right-0 z-10 mt-3 w-80">
                                    <div className="bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 px-4 py-3">
                                        <h2 className="font-semibold text-gray-700">Notifications</h2>
                                        <p className="text-sm mt-2 text-gray-600">No recent activity.</p>
                                    </div>
                                </PopoverPanel>
                            </Transition>
                        </>
                    )}
                </Popover> */}

                {/* Profile Menu */}
                <Menu as="div" className="relative">
                    <div>
                        <MenuButton className="flex items-center space-x-2 bg-gray-100 hover:bg-gray-200 px-2 py-1 rounded-full focus:outline-none">
                            <img src={profileImage} alt="Profile" className="h-9 w-9 rounded-full object-cover" />
                            <span className="hidden md:block text-sm font-medium text-gray-700">
                                {' '}
                                {userName || 'User'}
                            </span>
                        </MenuButton>
                    </div>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <MenuItems className="absolute right-0 z-20 mt-2 w-48 origin-top-right rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <MenuItem>
                                {({ active }) => (
                                    <div
                                        onClick={() => navigate('/profile/info')}
                                        className={classNames(
                                            active ? 'bg-gray-100' : '',
                                            'px-4 py-2 flex items-center gap-2 text-gray-700 cursor-pointer'
                                        )}
                                    >
                                        <HiOutlineUser className="text-lg" />
                                        Your Profile
                                    </div>
                                )}
                            </MenuItem>
                            <MenuItem>
                                {({ active }) => (
                                    <div
                                        onClick={handleLogout}
                                        className={classNames(
                                            active ? 'bg-gray-100' : '',
                                            'px-4 py-2 flex items-center gap-2 text-red-600 cursor-pointer'
                                        )}
                                    >
                                        <HiOutlineLogout className="text-lg" />
                                        Sign out
                                    </div>
                                )}
                            </MenuItem>
                        </MenuItems>
                    </Transition>
                </Menu>
            </div>
        </header>
    )
}
